// Small wrapper so you don’t call window.gtag directly everywhere
export const triggerAnalytics = ({ eventName, params = {} }) => {
  if (typeof window.gtag !== "function") {
    console.warn("gtag not available, event skipped:", eventName, params);
    return;
  }
  window.gtag("event", eventName, params);
};

// 🎮 Game Events
export const logGameStart = ({ gameSettings }) => {
  const { mode, title, time } = gameSettings;
  triggerAnalytics({
    eventName: "game_start",
    params: {
      game_mode: mode,
      game_difficulty: title,
      game_time: time,
    },
  });
};

export const logPlayAgain = ({ gameSettings }) => {
  const { mode, title, time } = gameSettings;
  triggerAnalytics({
    eventName: "play_again",
    params: {
      game_mode: mode,
      game_difficulty: title,
      game_time: time,
    },
  });
};

// Do I need game end? Yes at least to see if people are finishing the game
export const logGameEnd = ({ gameSettings, score }) => {
  const { mode, title, time } = gameSettings;
  triggerAnalytics({
    eventName: "game_end",
    params: {
      game_mode: mode,
      game_difficulty: title,
      game_time: time,
      score_value: score,
    },
  });
};

// 🏆 Leaderboard
export const logLeaderboardView = ({ difficultyTitle }) => {
  triggerAnalytics({
    eventName: "leaderboard_view",
    params: { game_difficulty: difficultyTitle },
  });
};

export const logLeaderboardShareScore = ({ difficultyTitle }) => {
  triggerAnalytics({
    eventName: "leaderboard_share_score",
    params: { game_difficulty: difficultyTitle },
  });
};

// 👥 Multiplayer
export const logMultiplayerStart = ({ gameSettings }) => {
  const { difficultyString, title, point } = gameSettings;
  triggerAnalytics({
    eventName: "local_multiplayer_start_game",
    params: {
      game_difficulty: difficultyString,
      game_mode: title,
      points_to_win: point,
    },
  });
};

// Do I need game end?
export const logMultiplayerEnd = ({ gameSettings }) => {
  const { difficultyString, title, point } = gameSettings;
  triggerAnalytics({
    eventName: "local_multiplayer_end_game",
    params: {
      game_difficulty: difficultyString,
      game_mode: title,
      points_to_win: point,
    },
  });
};

export const logMultiplayerPlayAgain = ({ gameSettings }) => {
  const { difficultyString, title } = gameSettings;
  triggerAnalytics({
    eventName: "local_multiplayer_play_again",
    params: {
      game_difficulty: difficultyString,
      game_mode: title,
    },
  });
};

// 👤 Auth
export const logSignUp = () => {
  triggerAnalytics({ eventName: "sign_up" });
};

export const logLogin = () => {
  triggerAnalytics({ eventName: "login" });
};

export const logSignOut = () => {
  triggerAnalytics({ eventName: "sign_out" });
};

// 📘 Tutorial / How to play
export const logHowToPlayView = () => {
  triggerAnalytics({ eventName: "how_to_play_view" });
};

// 🎛️ UI Navigation
export const logMenuClick = ({ itemName }) => {
  triggerAnalytics({
    eventName: "menu_button_click",
    params: { item_name: itemName },
  });
};
